// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3HNGk","tab":"ProcedureTabs_tab__1Cvrb"};